import React, { Component }     from 'react';
import logo                     from './logo';
import mail                     from './mail';

const icons = {
  logo,
  mail
};

export default class Icon extends Component {
  render() {

    const className = this.props.className ? this.props.className : '';
    const styles    = {
      color: this.props.color ? this.props.color : '',
      width: this.props.width ? this.props.width : ''
    }

    return (
      <div className={ `icon icon-${this.props.icon} ${className}`} style={ styles }>
        <span dangerouslySetInnerHTML={{ __html: icons[this.props.icon] }} />
      </div>
    )
    
  }
}



// WEBPACK FOOTER //
// ./src/components/icon/index.js